const operationPackageInstanceEn = {
  action: {
    approveAll: "Approve all",
    approveAllSuccess: "Approved all successfully",
    cannotApproveAll:
      "Cannot approve all because there are no waiting approval tasks",
    abort: "Abort",
    abortSuccess: "Aborted successfully",
  },
  tableHeader: {
    requestedFor: "Requested for",
    progress: "Progress",
  },
  task: {
    deadline: "Deadline",
    assignee: "Assignee",
    target: "Target",
  },
};

export default operationPackageInstanceEn;
